module.exports = __webpack_public_path__ + "static/media/Rasmus-Cervator-Praestholm.de6fdeeb.jpg";